interface Config {
  env: string;
  publicKey: string;
  localDomainUrl: string;
  qaDomainUrl: string;
  stageDomainUrl: string;
  prodDomainUrl: string;
  xApiKey: string;
  stageCognitoUrl: string;
  qaCognitoUrl: string;
  localCognitoUrl: string;
  prodCognitoUrl:string;
  faqRequired: boolean;
  userEndPoints: {
    getSsoUrl: string;
    ssoLogin: string;
    ssoLogout: string;
    userMeta: string;
    trainers: string;
    userConsentRequest: string;
    orgAdmins: string;
    consentRequest: string;
    uploadDocument: string;
    userDocuments: string;
    uploadfeedback: string;
    userConsentRequestStatus: string;
    encryptionConfig: string;
    userConsentExport: string;
  };
  trainingEndPoints: {
    organizations: string;
    trainingSessions: string;
    documentUpload: string;
    getDocumentList: string;
    trainingUpdateRequest: string;
    finalizeRoster:string;
    downloadStudentTemplate: string;
    studentsUpload: string;
    studentsUploadHistory: string;
    students: string;
    downloadUploadDocument: string
    student: string;
    trainingStatus: string;
    addStudentCertificate: string;
    approveFeedBackDocument: string;
    generateEligibleStudentsCertificate: string;
    promoteUser: string;
    cadre: string;
    hospital: string;
    feedBackReminder: string;
    converthtmltopdf: string;
    certificate: string;
    orgExport: string;
    trainingSessionExport: string;
    studentExport: string;
    trainerExport:string;
  };
  [key: string]: any;
}

const config: Config = {
  env: process.env.REACT_APP_WHO_ENV ?? "local",
  publicKey: process.env.REACT_APP_PUBLIC_KEY ?? "",
  localDomainUrl: "https://bec-qa-api.heartblr.org",
  qaDomainUrl: "https://bec-qa-api.heartblr.org",
  stageDomainUrl: "https://bec-stage-api.heartblr.org",
  prodDomainUrl:"https://api.bectraining.org/",
  localClientId: "b7rg920i65h4qrj6pfmkra2j0",
  qaClientId: "b7rg920i65h4qrj6pfmkra2j0",
  stageClientId: "telcrdbv5ptlk709trlpoq3u8",
  prodClientId: "4mkbjamrnbbdrlu0jg56d89fcc",
  maxCertificateDownload: process.env.REACT_APP_MAX_CERT_DOWNLOAD ?? 10,
  xApiKey: process.env.REACT_APP_X_API_KEY  ?? "",
  stageCognitoUrl: "https://bec-stage-sso.auth.us-east-1.amazoncognito.com",
  qaCognitoUrl: "https://bec-dev-sso.auth.us-east-1.amazoncognito.com",
  localCognitoUrl: "https://bec-dev-sso.auth.us-east-1.amazoncognito.com",
  prodCognitoUrl: "https://bec-prod-sso.auth.us-east-1.amazoncognito.com",
  faqRequired: process.env.REACT_APP_FAQ === "true",
  userEndPoints: {
    getSsoUrl: "/user/v1/getSsoUrl",
    ssoLogin: "/user/v1/ssoLogin",
    ssoLogout: "/user/v1/logout",
    userMeta: "/user/v1/userMeta",
    trainers: "/user/v1/trainers",
    userConsentRequest: "/user/v1/userConsentRequest",
    orgAdmins: "/user/v1/orgAdmins",
    consentRequest: "/user/v1/consentRequest",
    uploadDocument: "/user/v1/uploadDocument",
    userDocuments: "/user/v1/userDocuments",
    uploadfeedback: "/user/v1/uploadfeedback",
    userConsentRequestStatus: "/user/v1/userConsentRequestStatus/",
    encryptionConfig: "/user/v1/encryptionConfig",
    userConsentExport: "/user/v1/consentRequests/export",
  },
  trainingEndPoints: {
    organizations: "/training/v1/organizations",
    trainingSessions: "/training/v1/trainingSessions",
    documentUpload: "/training/v1/documentUpload",
    getDocumentList: "/training/v1/listOfUploadDocument",
    trainingUpdateRequest: "/training/v1/trainingUpdateRequest",
    finalizeRoster: "/training/v1/finalizeRoster",
    downloadStudentTemplate: '/training/v1/downloadStudentTemplates',
    studentsUpload: "/training/v1/studentsupload",
    studentsUploadHistory: '/training/v1/studentsUploadHistory',
    students: "/training/v1/students",
    downloadUploadDocument: "/training/v1/downloadUploadDocument",
    student: "/training/v1/student",
    trainingStatus: "/training/v1/trainingStatus/",
    addStudentCertificate: "/training/v1/addstudentcertificate",
    approveFeedBackDocument: "/training/v1/approveFeedBackDocument",
    generateEligibleStudentsCertificate: "/training/v1/generateEligibleStudentsCertificate",
    promoteUser: "/training/v1/promoteUser",
    cadre: "/training/v1/organizations/cadre",
    hospital: "/training/v1/organizations/hospital",
    feedBackReminder: "/training/v1/feedBackReminder",
    converthtmltopdf: "/training/v1/converthtmltopdf",
    certificate:"/training/v1/certificate",
    orgExport: "/training/v1/organizations/export",
    trainingSessionExport: "/training/v1/trainingSessions/export",
    studentExport: "/training/v1/exportStudents",
    trainerExport: "/training/v1/trainingSessions/exportTrainer",
  },
};

export const OPEN_URLS = [
  config.userEndPoints.getSsoUrl,
  config.userEndPoints.ssoLogin,
  config.userEndPoints.encryptionConfig,
];

export default config;
